const DaysHome = [
	{ value: 2, label: 2 },
	{ value: 3, label: 3 }
];

export default DaysHome;



// WEBPACK FOOTER //
// ./src/data/DaysHome.js